import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server'
import { UI_HEIGHT } from '../Common/constants';
import { __GAPI_KEY__ } from '../Common/keys';
import GoogleApiComponent from './utils/googleApiComponent';

export class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
        }
        this.onMapClicked = this.onMapClicked.bind(this);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onInfoWindowClose = this.onInfoWindowClose.bind(this);
    }

    onMarkerClick(props, marker, e) {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    }

    onInfoWindowClose() {
        this.setState({
            showingInfoWindow: false,
            activeMarker: null
        })
    }

    onMapClicked(props) {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            })
        }
    }

    render() {
        const { currentWarehouse, responsive } = this.props

        // console.log(this.state.selectedPlace);
        // console.log(this.state.activeMarker);

        if (!this.props.loaded) {
            return <div>Loading...</div>
        }
        return (
            <div >
                <Map google={this.props.google} currentWarehouse={currentWarehouse.coordinate} responsive={responsive}>
                    <Marker
                        position={currentWarehouse.coordinate}
                        onClick={this.onMarkerClick}
                        name={currentWarehouse.WarehouseTitle}
                        contact = {currentWarehouse.Contact}
                        address = {currentWarehouse.Address}
                        />
                </Map>
            </div>
        )
    }
}

// <InfoWindow
//     marker={this.state.activeMarker}
//     visible={this.state.showingInfoWindow}
//     onClose={this.onInfoWindowClose}>
//     <div>
//         {this.state.selectedPlace.name &&
//             <div>
//                 <h3>{this.state.selectedPlace.name}</h3>
//                 <ul>
//                     <li>Contact: {this.state.selectedPlace.contact || "-"}</li>
//                     <li>Address: {this.state.selectedPlace.address || "-"}</li>
//                 </ul>
//             </div>}
//         {!this.state.selectedPlace.name && <h3>Current Location</h3>}
//     </div>
// </InfoWindow>

export class Map extends Component {
    constructor(props) {
        super(props);

        const {lat, lng} = this.props.initialCenter;
        this.state = {
            // define the height of the map
            mapHeight: window.innerHeight - UI_HEIGHT.noButton,

            // listen to the current location
            currentLocation: {
                lat: lat,
                lng: lng
            },

        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        if (this.props.centerAroundCurrentLocation) {
            if (navigator && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((pos) => {
                    const coords = pos.coords;
                    this.setState({
                        currentLocation: {
                            lat: coords.latitude,
                            lng: coords.longitude
                        }
                    })
                })
            }
        }

        // Load the google map when component mount.
        this.loadMap();
    }

    // Load the map when google props changed.
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
            this.loadMap();
        }

        // Move the map's center to current location
        if (prevState.currentLocation !== this.state.currentLocation) {
            this.moveMap();
        }

        if (prevProps.currentWarehouse !== this.props.currentWarehouse && this.props.currentWarehouse) {
            this.setState({ currentLocation: this.props.currentWarehouse });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // resize the map to fit resolution
    handleResize(e) {
        this.setState({ mapHeight: window.innerHeight - UI_HEIGHT.noButton });
    }

    loadMap() {
        if (this.props && this.props.google) {
            // google is available
            const {google} = this.props;
            const maps = google.maps;

            const mapRef = this.refs.map;
            const node = ReactDOM.findDOMNode(mapRef);

            const { zoom } = this.props;
            const {lat, lng} = this.state.currentLocation;
            const center = new maps.LatLng(lat, lng);
            const mapConfig = Object.assign({}, {
                center: center,
                zoom: zoom
            })
            this.map = new maps.Map(node, mapConfig);
        }
    }

    // use panTo to rerender the map
    moveMap() {
        const map = this.map;
        const curr = this.state.currentLocation;

        const google = this.props.google;
        const maps = google.maps;

        if (map) {
            let center = new maps.LatLng(curr.lat, curr.lng)
            map.panTo(center)
        }
    }

    renderChildren() {
        const {children} = this.props;
        // If no children, return a null
        if (!children) return;

        // Make a clone for each child with given props
        return React.Children.map(children, c => {
            return React.cloneElement(c, {
                map: this.map,
                google: this.props.google,
                mapCenter: this.state.currentLocation
            });
        })
    }

    render() {
        const height = this.props.responsive ? this.state.mapHeight : "100px"
        const style = {
            width: '100%',
            height
        }
        return (
            <div ref='map' style={style}>
                Loading map...
                {this.renderChildren() }
            </div>
        )
    }
}

// Map props definition
Map.propTypes = {
    google: React.PropTypes.object,
    zoom: React.PropTypes.number,
    initialCenter: React.PropTypes.object,
    centerAroundCurrentLocation: React.PropTypes.bool
}

// Map default values
Map.defaultProps = {
    zoom: 13,
    // San Francisco, by default
    initialCenter: {
      lat: 33.992233,
      lng: -117.9142382,
    },
    centerAroundCurrentLocation: true
}

const wrappedPromise = function () {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
}

export const camelize = function (str) {
    return str.split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
}

const evtNames = ['click', 'mouseover', 'recenter'];

export class Marker extends Component {

    componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
    }

    componentDidUpdate(prevProps) {
        if ((this.props.map !== prevProps.map) ||
            (this.props.position !== prevProps.position)) {
            this.renderMarker();
        }
    }

    componentWillUnmount() {
        if (this.marker) {
            this.marker.setMap(null);
        }
    }

    getMarker() {
        return this.markerPromise;
    }

    handleEvent(evt) {
        return (e) => {
            const evtName = `on${camelize(evt)}`
            if (this.props[evtName]) {
                this.props[evtName](this.props, this.marker, e);
            }
        }
    }

    renderMarker() {
        let { map, google, position, mapCenter } = this.props;

        if (!google) {
            return null
        }

        let pos = position || mapCenter;
        position = new google.maps.LatLng(pos.lat, pos.lng);

        const pref = {
            map: map,
            position: position
        };

        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(e => {
            this.marker.addListener(e, this.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
    }

    render() {
        return null;
    }
}

Marker.propTypes = {
    position: React.PropTypes.object,
    map: React.PropTypes.object
}

evtNames.forEach(e => Marker.propTypes[e] = React.PropTypes.func)

// InfoWndow Component

class InfoWindow extends React.Component {
    constructor(props) {
        super(props);
        this.updateContent = this.updateContent.bind(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const {google, map} = this.props;

        if (!google || !map) {
            return;
        }

        if (this.props.map !== prevProps.map) {
            this.renderInfoWindow();
        }
        if (this.props.children !== prevProps.children) {
            this.updateContent();
        }
        if (this.props.visible !== prevProps.visible ||
            (this.props.marker !== prevProps.marker)) {
            this.props.visible ?
                this.openWindow() :
                this.closeWindow();
        }
    }

    componentDidMount() {
    }

    openWindow() {
        console.log(this)
        this.infowindow
            .open(this.props.map, this.props.marker);
    }
    closeWindow() {
        console.log(this)
        this.infowindow.close();
    }

    updateContent() {
        const content = this.renderChildren();
        this.infowindow
            .setContent(content);
        this.infowindow
            .open(this.props.map, this.props.marker);
    }

    renderInfoWindow() {
        console.log("Info", this.props);
        let {map, google, mapCenter} = this.props;

        if (!google || !google.maps) {
            return;
        }

        const iw = this.infowindow = new google.maps.InfoWindow({
            content: ''
        });
    }

    renderChildren() {
        console.log("children", this.props);
        const {children} = this.props;
        return ReactDOMServer.renderToString(children);
    }

    render() {
        return null;
    }
}

InfoWindow.propTypes = {
    children: React.PropTypes.element.isRequired,
    map: React.PropTypes.object,
    marker: React.PropTypes.object,
    visible: React.PropTypes.bool,
}

InfoWindow.defaultProps = {
    visible: false
}


export default GoogleApiComponent({
    apiKey: __GAPI_KEY__
})(Container)



// WEBPACK FOOTER //
// ./master/jsx/components/GoogleMap/googleMapContainer.jsx